const getYear = () => {
  const date = new Date();
  return date.getFullYear();
};

const getMonth = () => {
  const date = new Date();
  return date.getMonth();
};

const getDate = () => {
  const date = new Date();
  return date.getDate();
};

const getDay = () => {
  const date = new Date();
  return date.getDay();
};

const getHours = () => {
  const date = new Date();
  return date.getHours();
};

const getMinutes = () => {
  const date = new Date();
  return date.getMinutes();
};

const getSeconds = () => {
  const date = new Date();
  return date.getSeconds();
};

export {getYear, getMonth, getDate, getDay, getHours, getMinutes, getSeconds};
